// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CalculatorTwoToneSvg from "@ant-design/icons-svg/es/asn/CalculatorTwoTone";
import AntdIcon from '../components/AntdIcon';

var CalculatorTwoTone = function CalculatorTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CalculatorTwoToneSvg
  }));
};

CalculatorTwoTone.displayName = 'CalculatorTwoTone';
export default /*#__PURE__*/React.forwardRef(CalculatorTwoTone);